/* eslint-disable import/prefer-default-export */
import * as yup from "yup";
import { addressFieldsetSchema } from "components/Shared/Forms/AddressFieldset";
import { phoneNumberFieldsetSchema } from "components/Shared/Forms/PhoneInput";

export const orderingPlatformId = yup
  .string()
  .uuid()
  .required()
  .label("Customer");

export const name = yup
  .string()
  .label("Name")
  .required()
  .trim()
  .min(2)
  .ensure();

export const code = yup
  .string()
  .label("Code")
  .nullable()
  .defined()
  .trim()
  .default(null);

export const notes = yup.string().label("Notes").defined().trim().ensure();

export const address = addressFieldsetSchema;

export const phoneNumber = phoneNumberFieldsetSchema.label("Phone Number");
